export default __webpack_public_path__ + "media/convenience_banner_mobile.dc9dbe1c.png";